import {useLocation} from "react-router-dom";
import ProductCard from "../ProductCard/ProductCard";
import "./SearchPage.scss";

const SearchPage = () => {

  const location = useLocation();
  const resultData = location.state.items;
  const searchWord = location.state.word;

  return (
    <div className="search-page">
      <h3 style={{
        padding: "40px",
        fontWeight: "500",
        color: "#646464",
        display: 'flex',
        columnGap: '8px',
        alignItems: 'center'
      }}>
        نتایج جستجوی شما برای عبارت{" "}
        <span style={{color: "#54B1A9"}}>{searchWord}</span> :
        {resultData.length === 0 && <span>نتیجه ای یافت نشد</span>}
      </h3>
      {resultData.length > 0 &&
        <div className="ProductCardContainer__">
          {resultData.map((v, index) => {
            return (
              <ProductCard
                url={v?.url}
                key={"lo" + index}
                title={v?.title}
                src={v?.images.length > 1 && v?.images[0].url}
                inventory={v?.inventory}
                id={v?.id}
                mainPrice={v?.mainPrice}
                offer={v?.offer}
                offerPrice={v?.offerPrice}
                offPercent={v?.offPercent}
                score={v?.score}
                cardModel={v?.cardModel}
                className={"cardWidth__"}
              />
            );
          })}
        </div>}
    </div>
  );
};

export default SearchPage;
